var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('router-view'),_c('v-snackbar',{attrs:{"color":_vm.snackbar.color,"content-class":"text-center"},model:{value:(_vm.snackbar.isVisible),callback:function ($$v) {_vm.$set(_vm.snackbar, "isVisible", $$v)},expression:"snackbar.isVisible"}},[_vm._v(" "+_vm._s(_vm.snackbar.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }